<template>
  <PresaleForm></PresaleForm>
</template>

<script>
import PresaleForm from '@/components/PresaleForm'

export default {
  components: { PresaleForm }
}
</script>

